import axios from "axios";
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const GET_USUARIO = `${API_URL}/persona/`;

export async function getUsuarioActual() {
   return await axios({
     method: "GET",
     url: GET_USUARIO,
   })
     .then((response) => response.data)
     .catch(
       (response) =>
         (response.data = "Error: Fallo en recoger los datos personales.")
     );
}
